import { apiClient } from './client';

export interface DeptMetricRow {
  department_id: string | null;
  department_name: string;
  session_count: number;
  participant_count: number;
  mean: number | null;
}

export interface DeptRollup {
  metric: string;
  unit: string | null;
  /** higher | lower | none — which direction is "better". */
  direction: string;
  rows: DeptMetricRow[];
}

/** Curated metric options for the department-analytics picker. Keys match
 *  the backend registry (app/services/cohort_baseline.METRICS). */
export const DEPT_METRIC_OPTIONS: {
  key: string;
  label: string;
  group: 'Cognitive' | 'Motion' | 'Other';
}[] = [
  { key: 'focus', label: 'Focus', group: 'Cognitive' },
  { key: 'engagement', label: 'Emotional Engagement', group: 'Cognitive' },
  { key: 'valence', label: 'Valence', group: 'Cognitive' },
  { key: 'workload', label: 'Workload', group: 'Cognitive' },
  { key: 'bidex_v2', label: 'Bimanual Coactivity', group: 'Motion' },
  { key: 'idle_time_fraction', label: 'Idle Time', group: 'Motion' },
  { key: 'duration', label: 'Session Duration', group: 'Other' },
];

export async function getByDepartment(
  tenantId: string,
  metric: string,
): Promise<DeptRollup> {
  const { data } = await apiClient.get<DeptRollup>(
    `/api/v1/tenants/${tenantId}/analytics/by-department`,
    { params: { metric } },
  );
  return data;
}
